module.exports = __webpack_public_path__ + "img/description@2x.340b8f09.png";